import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer id="footer" className="bg-brand-blue text-white pt-16 pb-8 md:pt-20 md:pb-10" data-id="element-46">
      <div className="container mx-auto px-4 md:px-6" data-id="element-47">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16" data-id="element-48">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-1 space-y-6" data-id="element-49">
            <div className="flex items-center gap-2" data-id="element-50">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center" data-id="element-51">
                <span className="text-brand-blue font-bold text-xl" data-id="element-52">C</span>
              </div>
              <div className="flex flex-col" data-id="element-53">
                <span className="text-white font-extrabold text-xl leading-tight tracking-tight" data-id="element-54">
                  CAREBRIDGE
                </span>
                <span className="text-blue-200 text-[10px] font-bold tracking-widest uppercase" data-id="element-55">
                  Transportation
                </span>
              </div>
            </div>
            <p className="text-blue-100 leading-relaxed" data-id="element-56">
              Providing professional, compassionate non-emergency medical
              transportation services across the region.
            </p>
            <div className="flex gap-4" data-id="element-57">
              {[{
              Icon: Facebook,
              label: 'Facebook'
            }, {
              Icon: Twitter,
              label: 'Twitter'
            }, {
              Icon: Linkedin,
              label: 'LinkedIn'
            }, {
              Icon: Instagram,
              label: 'Instagram'
            }].map(({
              Icon,
              label
            }, i) => <a key={i} href="#" className="w-10 h-10 rounded-full border border-blue-400 flex items-center justify-center hover:bg-white hover:text-[#002D72] transition-all focus-visible:ring-2 focus-visible:ring-white outline-none" aria-label={`Follow us on ${label}`} data-id="element-58">
                  <Icon size={20} aria-hidden="true" data-id="element-59" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Footer Quick Links" className="col-span-1" data-id="element-60">
            <h4 className="text-lg md:text-xl font-bold mb-4 md:mb-6" data-id="element-61">
              Quick Links
            </h4>
            <ul className="space-y-3 md:space-y-4 text-sm md:text-base text-blue-100" data-id="element-62">
              {[{
              name: 'About Us',
              path: '/about'
            }, {
              name: 'Services',
              path: '/services'
            }, {
              name: 'Employees',
              path: '/employees'
            }, {
              name: 'FAQ',
              path: '/faq'
            }, {
              name: 'Careers',
              path: '/employees'
            }, {
              name: 'Pay Now',
              path: '#'
            }].map(link => <li key={link.name} data-id="element-63">
                  <Link to={link.path} className="hover:text-white transition-colors focus-visible:underline outline-none" aria-label={`Go to ${link.name}`} data-id="element-64">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </nav>

          {/* Services */}
          <div className="col-span-1" data-id="element-65">
            <h4 className="text-lg md:text-xl font-bold mb-4 md:mb-6" data-id="element-66">
              Our Services
            </h4>
            <ul className="space-y-3 md:space-y-4 text-sm md:text-base text-blue-100" data-id="element-67">
              {['Stretcher Transport', 'Wheelchair Transport', 'Ambulatory Transport', 'Bariatric Transport', 'Long Distance'].map(service => <li key={service} data-id="element-68">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-69">
                    {service}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 lg:col-span-1" data-id="element-70">
            <h4 className="text-lg md:text-xl font-bold mb-4 md:mb-6" data-id="element-71">
              Contact Us
            </h4>
            <ul className="space-y-4 md:space-y-6 text-sm md:text-base text-blue-100" data-id="element-72">
              <li className="flex gap-4" data-id="element-73">
                <MapPin className="shrink-0 text-blue-300" data-id="element-74" />
                <span data-id="element-75">
                  123 Medical Plaza Way,
                  <br data-id="element-76" />
                  Suite 100, City, ST 12345
                </span>
              </li>
              <li className="flex gap-4" data-id="element-77">
                <Phone className="shrink-0 text-blue-300" data-id="element-78" />
                <span data-id="element-79">(555) 123-4567</span>
              </li>
              <li className="flex gap-4" data-id="element-80">
                <Mail className="shrink-0 text-blue-300" data-id="element-81" />
                <span data-id="element-82">info@carebridge.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-10 border-t border-blue-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-blue-300" data-id="element-83">
          <p data-id="element-84">
            © {new Date().getFullYear()} CareBridge Transportation. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-85">
            <a href="#" className="hover:text-white" data-id="element-86">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-87">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}